/* ---------------------------------------------------------------------------
   LAMOUR MULTIBUY INFO — product-page panel behaviour
   ---------------------------------------------------------------------------
   Two jobs, both for the MultiBuy panel rendered by snippets/lamour-product-multibuy-info.liquid:

     1. Toggle the "Buy 2 — Unlock MultiBuy Discount" panel open/closed.
     2. On the FIRST open, lazy-fetch up to 3 same-region products and reveal the
        "More From This Region" container.

   The fetch calls the huipiles collection through Shopify's Section Rendering API
   (sections/region-related.liquid, which is deliberately not placed in any template),
   filtered by the custom.region metafield, then drops the current product from the
   results. It FAILS SILENT — on any error the container just stays hidden — matching
   the image-retry.js / lamour-reviews-widget.js convention.

   Container attributes (set by the Liquid snippet):
     data-collection-url    huipiles collection URL to fetch from
     data-region            this product's custom.region value
     data-current-handle    this product's handle, so it can exclude itself
   --------------------------------------------------------------------------- */

(function () {
  var RELATED_LIMIT = 3;

  // Delegated so it survives the panel being re-rendered by the theme editor.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.multibuy-info-button')) return;
    e.preventDefault();

    var panel = document.getElementById('multibuy-btn');
    if (panel) panel.classList.toggle('open');
  });

  function initRegionRelated() {
    var wrapper = document.querySelector('.region-related');
    if (!wrapper || wrapper.dataset.regionRelatedBound === 'true') return;

    var toggleButton = document.querySelector('.multibuy-info-button');
    if (!toggleButton) return;

    wrapper.dataset.regionRelatedBound = 'true';

    toggleButton.addEventListener('click', function loadRegionRelated() {
      toggleButton.removeEventListener('click', loadRegionRelated);

      var url =
        wrapper.dataset.collectionUrl +
        '?filter.p.m.custom.region=' +
        encodeURIComponent(wrapper.dataset.region) +
        '&section_id=region-related';

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = Array.prototype.slice.call(doc.querySelectorAll('product-card'));

          var related = cards
            .filter(function (card) {
              return card.getAttribute('handle') !== wrapper.dataset.currentHandle;
            })
            .slice(0, RELATED_LIMIT);

          if (related.length === 0) return;

          var list = wrapper.querySelector('.region-related__list');
          if (!list) return;

          related.forEach(function (card) {
            list.appendChild(card);
          });

          wrapper.hidden = false;
        })
        .catch(function () {
          // Fails silent — the container stays hidden.
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRegionRelated);
  } else {
    initRegionRelated();
  }

  // Re-bind after the theme editor re-renders the section (fires in the editor only).
  document.addEventListener('shopify:section:load', initRegionRelated);
})();
